export enum EventNames {
  USER_SESSION_DATA = 'app-space:userSessionData',
  RELOAD_USER_SESSION_DATA = 'app-space:reloadUserSessionData',
  VIEW_AS_DATA = 'app-space:viewAsData'
}
